export const categoryKeys = {
  roots: () => ["categories", "roots"] as const,
  children: (parentId: number) => ["categories", "children", parentId] as const,
  detail: (id: number) => ["categories", "detail", id] as const,
  songs: (id: number) => ["categories", "songs", id] as const,
};
